import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, Inject, inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import { DashboardComponent } from '../../../dashboard/dashboard.component';
import { MatInputModule } from '@angular/material/input';
import { NgOtpInputComponent, NgOtpInputModule } from 'ng-otp-input';
import Swal from 'sweetalert2';
import { iDebitOrderMandate, ILead, IResponse } from 'app/core/shared-services/shared-interface.types';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MandateAuthStatusService } from 'app/core/shared-services/mandate-auth-status.service';


@Component({
  standalone: true,
  selector: 'app-mandate-popup',
  templateUrl: './mandate-popup.component.html',
  styleUrls: ['./mandate-popup.component.scss'],
  imports: [MatDialogModule, MatFormFieldModule, NgIf, MatIconModule, MatButtonModule, DashboardComponent, MatInputModule, NgOtpInputModule],

})
export class MandatePopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { mandateData: any, lead: ILead },
    @Inject(PLATFORM_ID) private platformId: any

  ) { }
  public mandateData: iDebitOrderMandate
  public mandateAuthStatus: string = "Undefined";

  // ## VARS ##

  // public mandateData: any;
  public iframeUrl: any;
  public timer: any;
  public debitOrderAction: any;
  public awaitingOTP: boolean = false;
  public otpTimer: number;
  private otp: number;
  private referrer: string;
  dealerCode: string;
  isDealerJourney: boolean;



  // ## DEPENDENCIES ##
  private sanitizer = inject(DomSanitizer);
  private _sharedMethods = inject(SharedMethodsModule);
  public dialogRef = inject(MatDialogRef<MandatePopupComponent>);
  public _sharedService = inject(SharedServiceService);
  private _gtmService = inject(GtmService);
  private router = inject(Router);
  private activatedRouter = inject(ActivatedRoute);
  private _mandateAuthStatusService = inject(MandateAuthStatusService);



  // ## HOOKS ##
  async ngOnInit() {

    this.isDealerJourney = this.activatedRouter.snapshot.url.some(segment => segment.path === 'pre-orders');

    const dealerCodeRaw = localStorage.getItem('DealerCode');
    if (dealerCodeRaw !== null) {
      this.dealerCode = JSON.parse(dealerCodeRaw);
    } else {
      this.dealerCode = null;
    }

    if(localStorage.getItem('currentURL')) {
      if(localStorage.getItem('currentURL') == window.location.href) {
        //this.referrer = window.location.href
      } else {
        this.referrer = localStorage.getItem('currentURL')
        localStorage.setItem('currentURL', window.location.href);
        localStorage.setItem('previousURL', this.referrer);
      }
    } else {
      localStorage.setItem('currentURL', window.location.href);
    }

    this._mandateAuthStatusService.currentMandateAuthorizationStatus.subscribe(status => this.mandateAuthStatus = status)
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(await this._sharedMethods.previewDebitOrderMandate(this.data.mandateData?.EntityAccountDebitOrderMandateID, 'Bearer ' + localStorage.getItem('accessToken')));
    this.mandateData = this.data.mandateData
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  ngOnChanges() {
  }



  // ## METHODS ##
  public closeDialog() {
    this.dialogRef.close();
  }


  public async actionDebitOrder(action: string) {
    if (action == 'Accept' || action == 'Resend') {

      const route = window.location.href;
      const path = this.router.url;

      // if (this.activatedRouter.snapshot.queryParamMap.get('username')) {
      //   this._gtmService.pushEvent({ 
      //     event: 'accept_debit_order_dealer',
      //     page_url: route,
      //     page_path: path,
      //     page_referrer: this.referrer ? this.referrer : route,
      //     page_title: 'pre-orders_page',
      //     dealer_code: this.dealerCode
      //   });
      // }
    
        try {

          
          if (isPlatformBrowser(this.platformId)) {
            const route = window.location.href;
            const path = this.router.url;
            
              this._gtmService.pushEvent({ 
                event: 'accept_debit_order',
                page_url: route,
                page_path: path,
                page_referrer: this.referrer ? this.referrer : route,
                page_title: 'pre-orders_page',
                dealer_code: this.dealerCode
            });

        }
      } 
      catch (error) {
            console.error('Error pushing GTM event:', error);
      }

      this.debitOrderAction = await this._sharedMethods.acceptDebitOrderOTP(this.data.mandateData?.EntityAccountDebitOrderMandateID);
      // console.log(this.debitOrderAction);

      if (this.debitOrderAction.success) {
        this.initOtp(); //Initialize OTP Timer
      }

    } else if (action == 'Reject') {

      if (isPlatformBrowser(this.platformId)) {
        const route = window.location.href;
        const path = this.router.url;
        if (!this.isDealerJourney) {
            this._gtmService.pushEvent({ 
              event: 'decline_debit_order',
              page_url: route,
              page_path: path,
              page_referrer: this.referrer ? this.referrer : route,
              page_title: 'pre-orders_page',
          });
        }
    }
      
      this.debitOrderAction = await this._sharedMethods.rejectDebitOrderMandate(this.data.mandateData?.EntityAccountDebitOrderMandateID);
      if (this.debitOrderAction.success) {
        Swal.fire({
          toast: true,
          timer: 3000,
          position: 'bottom-end', 
          title: 'Order Rejected!',
          icon: 'success',
          showCancelButton: false,
          showConfirmButton: false,
          customClass: {
            htmlContainer: 'text-xl',
            confirmButton: 'custom-button text-lg',
          }
        }).then(() => {
          this.updateMandateAuthServiceStatus("Rejected");
          this.closeDialog();

        });

      } else {
        Swal.fire({
          title: 'Failed to Reject Order!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          customClass: {
            htmlContainer: 'text-xl',
            confirmButton: 'custom-button text-lg',
          }
        });
      }
    }
  }

  public async authoriseMandate() {
    this._sharedMethods.authoriseMandateWithOTP(this.data.mandateData.EntityAccountDebitOrderMandateID, this.otp).then((res: IResponse) => {
      if (res.success) {
        //Submit OTP is successful
        try {
            if (isPlatformBrowser(this.platformId)) {


            const route = window.location.href;
            const path = this.router.url;

            if (this.isDealerJourney) {
              this._gtmService.pushEvent({ 
                event: 'submit_OTP_debit_order_dealer' ,
                page_url: route,
                page_path: path,
                page_referrer: this.referrer ? this.referrer : route,
                dealer_code: this.dealerCode
              });
            } else {
              this._gtmService.pushEvent({ 
                event: 'submit_OTP_debit_order' ,
                page_url: route,
                page_path: path,
                page_referrer: this.referrer ? this.referrer : route
              });
            }
          }
          } catch (error) {
            console.error('Error pushing GTM event:', error);
          }
        Swal.fire({
          title: 'OTP Submitted Successfully!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          allowOutsideClick: false,
          customClass: {
            htmlContainer: 'text-xl',
            confirmButton: 'bg-primary custom-button text-lg',
          },
          willClose: () => {
            // this.closeDialog();

            // Once authorized, will only then display Upfront Payment on Payment Component
            this.updateMandateAuthServiceStatus("Authorized");
            this.dialogRef.close();
          }
        });

        //Emit mandate authorized

        // .then(() => {
        //   this.closeDialog();
        // });

      } else {
        this.otpTimer = 1;
        Swal.fire({
          title: 'Incorrect Otp!',
          text: 'Please try again.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          allowOutsideClick: false,
          customClass: {
            htmlContainer: 'text-xl',
            confirmButton: 'bg-primary custom-button text-lg',
          }
        });
      }
    });
  };

  /**
     * OTP Value Change
     */
  public onOtpChange(val: any) {
    // only if the 6'th value is inserted, save the otp
    if (val.length == 6) {
      this.otp = val
    }
  }


  async openInNewTab() {
    const pdfUrl = await this._sharedMethods.previewDebitOrderMandate(this.data.mandateData?.EntityAccountDebitOrderMandateID, 'Bearer ' + localStorage.getItem('accessToken'));
    const sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
    window.open(pdfUrl, '_blank');
  }

  private initOtp() {
    this.otpTimer = 60;
    this.awaitingOTP = true;
    this.timer = setInterval(() => {
      if (this.otpTimer > 0) {
        this.otpTimer--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }
  


  updateMandateAuthServiceStatus(status: string) {
    this._mandateAuthStatusService.changeMandateAuthorizationStatus(status)
  }



}




